import * as _utils from './_utils';

const local: () => Env = () => {
  const envcode: Envcode = 'local';

  return {
    NAME: 'ローカル環境',
    COGNITO_REGION: 'us-west-2',
    COGNITO_USER_POOL_ID: 'us-west-2_9PhHUvuPf',
    COGNITO_CLIENT_ID: '4h89ej3l8pg6r0apafc4o3n2hv',
    COGNITO_REDIRECT_URI: 'http://localhost:3333/signin',
    COGNITO_DOMAIN: 'https://tf-an-local.auth.us-west-2.amazoncognito.com',
    API_ENDPOINT: 'http://localhost:3000/local',
    ENVCODE: envcode,
    TITLE: _utils.getName(envcode),
    STRIPE_PK: 'pk_test_aLCDECowCWXrI6io12XOoD1Y00ZQdcuR1j',
    RECAPTCHA_SITE_KEY: '6LeA_uwUAAAAAJRa8iDis4Ql9wjrZzzO_uxyY7ED',
  };
};

export default local();
